import React, { PropTypes } from "react";
import { Field, reduxForm } from "redux-form";
import { TextInput } from "../common/form";
import { FormattedMessage, intlShape, FormattedHTMLMessage } from "react-intl";
import * as intlActions from "../intl/intlActions";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as loginActions from "../login/loginActions";
import LanguageToggle from "../common/LanguageToggle/LanguageToggle";
import { toCamelCase } from "../common/form/DBEnumStringHelper";
import { updateCurrentURL } from "../../../utils/url";

class ResetPasswordForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.successfullPasswordReset = this.successfullPasswordReset.bind(this);
    this.setCurrentLocale = this.setCurrentLocale.bind(this);

    this.state = {
      resetSucceeded: false,
    };
  }

  componentDidMount() {
    const goToForgotPasswordPage = () =>
      this.props.router.push("/forgot-password");
    const hasError = (res) => !!res.payload.error;
    const goToForgotPasswordIfInvalid = (invalid) => {
      if (invalid) {
        goToForgotPasswordPage();
      }
    };

    this.props.loginActions
      .validatePasswordResetToken(this.props.token)
      .then(hasError)
      .then(goToForgotPasswordIfInvalid);
  }

  successfullPasswordReset(result) {
    this.setState({
      resetSucceeded: true,
      userFullName: `${result.firstName} ${result.lastName}`,
    });
  }

  setCurrentLocale(e) {
    this.props.intlActions.setLocale(e);
    updateCurrentURL("languageCode", e);
    /** We want to sync the LanguageToggle with the query param: languageCode. */
  }

  render() {
    const goToLogin = () => this.props.router.push("/login");
    const { resetSucceeded, userFullName } = this.state;
    const { firstName, isPasswordExpired, auth } = this.props;
    let errorMessageKey = "";

    if (auth && auth.errorType) {
      errorMessageKey = auth.errorType;
    } else if (
      auth &&
      auth.error &&
      auth.error.data &&
      auth.error.data.error === "invalidToken"
    ) {
      errorMessageKey = "invalidToken";
    }

    const isErrorMessageCamelCase = !errorMessageKey.match(/[\s_-]/g);
    /** returns false if key includes whitespace, _, or -. */

    return (
      <div>
        {!resetSucceeded && (
          <div>
            <LanguageToggle setLanguageCode={this.setCurrentLocale} />
            <h2>
              <FormattedMessage id="login.title" />
            </h2>
            <p className="instruction">
              {this.props.auth.isFetching ? null : this.props.auth.error ? (
                <span className="danger">
                  <span>
                    <FormattedHTMLMessage
                      id={`resetPassword.errors.${
                        !isErrorMessageCamelCase
                          ? toCamelCase(errorMessageKey)
                          : errorMessageKey
                      }`}
                    />
                  </span>
                </span>
              ) : (
                <span>
                  {isPasswordExpired && (
                    <span>
                      <FormattedMessage id="resetPassword.passwordExpired" />
                      <br />
                    </span>
                  )}
                  <FormattedMessage id="resetPassword.newPasswordInstructions" />
                </span>
              )}
            </p>
            <form
              onSubmit={this.props.handleSubmit((formData) =>
                this.props.loginActions.resetPassword(
                  formData,
                  this.props.token,
                  this.successfullPasswordReset
                )
              )}
            >
              {firstName && (
                <Field
                  id="firstName"
                  name="firstName"
                  component={TextInput}
                  className="login"
                  disabled={true}
                  input={{ value: firstName }}
                />
              )}

              <Field
                id="password"
                name="password"
                type="password"
                component={TextInput}
                className="login"
                placeholder={this.context.intl.formatMessage({
                  id: "resetPassword.password",
                })}
              />

              <Field
                id="confirm-password"
                name="confirm-password"
                type="password"
                component={TextInput}
                className="login"
                placeholder={this.context.intl.formatMessage({
                  id: "resetPassword.confirmPassword",
                })}
                fieldDescription={
                  <div>
                    <FormattedHTMLMessage id="validation.customMessages.passwordRules" />
                    <br />
                    <a
                      href={this.context.intl.formatMessage({
                        id: "validation.customMessages.passwordWebsite",
                      })}
                      target="_blank"
                    >
                      <FormattedMessage id="validation.customMessages.passwordWebsiteString" />
                    </a>
                  </div>
                }
              />
              <button type="submit" className="btn btn-lg btn-primary">
                <FormattedMessage id="resetPassword.change" />
              </button>
            </form>
          </div>
        )}
        {resetSucceeded && (
          <div>
            <p>
              <FormattedMessage
                id="resetPassword.userFullName"
                values={{ userFullName: userFullName }}
              />
            </p>
            <p>
              <FormattedMessage id="resetPassword.passwordChanged" />
            </p>
            <p>
              <FormattedMessage id="resetPassword.loginCredentials" />
              <a onClick={goToLogin}>
                <FormattedMessage id="resetPassword.followingLink" />
              </a>
            </p>
          </div>
        )}
      </div>
    );
  }
}

ResetPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  token: PropTypes.string,
  router: PropTypes.object,
  auth: PropTypes.object,
  loginActions: PropTypes.object.isRequired,
  intlActions: PropTypes.object,
  firstName: PropTypes.string,
  isPasswordExpired: PropTypes.bool,
};

ResetPasswordForm.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch),
    intlActions: bindActionCreators(intlActions, dispatch),
  };
}

export default reduxForm({
  form: "resetPassword",
})(connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPasswordForm)));



// WEBPACK FOOTER //
// ./src/components/reset-password/ResetPasswordForm.js